import React from "react";
import "./bec.scss";
import { Card, Col, CardTitle } from "reactstrap";
import { Link } from "react-router-dom";

function Becario() {
  return (
    <div className="d-flex p-5 justify-content-center">
      <Col id="colu">
        <Card body className="frm text-center">
          <CardTitle tag="h4">Bienvenido</CardTitle>
          <>
            <p>
              En caso de que haya sido aceptado para recibir y participar de la
              Beca en la institucion BQEF deberá completar el registro de sus
              datos.
            </p>
            <b>Por favor haga clic en el botón a continuación</b>
          </>

          <Link to="/Becario/regcomp" className="btn-bec" id="but">
            Continuar registro
          </Link>
        </Card>
      </Col>
    </div>
  );
}

export default Becario;
